// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Navbar from './components/navbar'
import Footer from './components/footer'
import Banner from './components/banner'
import blurimg from './functional/blurimg'
import VueGallery from 'vue-gallery'
import VueLazyload from 'vue-lazyload'
import VueForm from 'vue-form';


require('intersection-observer');


Vue.config.productionTip = true;

Vue.component("navBar",Navbar);
Vue.component("gallery",VueGallery);
Vue.component("footerFooter",Footer);
Vue.component("pageBanner",Banner);
Vue.component("blurimg",blurimg);

Vue.use(VueLazyload);
Vue.use(VueForm, {
	inputClasses: {
  	valid: 'form-control-success',
    invalid: 'form-control-danger'
  }
});

/* eslint-disable no-new */
var vm=new Vue({
  el: '#app',
  router,
  components: { App },
  template: "<App ref='application'/>"
})

window.onresize = function(){
  vm.$refs.application.$refs.routerView.getImages();
}



// WEBPACK FOOTER //
// ./src/main.js